import _ from "lodash";
import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import PrescriptionsTable from "./table-list/index";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../utils/hooks";
import TitleHeadSess from "../../utils/TitleHeadSess";
import { useAuth } from "../../auth/context";
import PatientAutocomplete from "../utils/patient/search/Autocomplete";

const queryKey = "medicalDocuments";

//TODO avoid repeating with medicalDocument/form/patient/index.jsx
const defaultPatient = { id: "", surname: "" };
const PatientPicker = ({ setPatient }) => {
  const form = useForm({ defaultValues: defaultPatient });
  const patientId = form.watch("id");

  useEffect(() => {
    const patient = form.getValues();
    setPatient(patient);
  }, [patientId]);

  return (
    <PatientAutocomplete
      form={form}
      helperText=""
      label={"Buscar"}
      noRequired={true}
    />
  );
};

const Prescriptions = () => {
  const api = useApi();
  const [patient, setPatient] = useState(defaultPatient);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const paginationOptions = { page, limit: rowsPerPage };

  const getMedicalDocuments = async () => {
    const patientFilter = patient.id && { patient: { id: patient.id } };
    const filters = _.assign({}, patientFilter);
    return api.medicalDocuments({ filters, ...paginationOptions });
  };

  const {
    isLoading: loading,
    data: { data: medicalDocuments, meta: { totalItems } = {} } = {},
  } = useQuery({
    queryKey: [queryKey, patient.id, paginationOptions],
    queryFn: () => getMedicalDocuments(),
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(queryKey);
    };
  }, [queryClient]);


  return (
    <Stack
      spacing="1rem"
      sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" }, width: "100%" }}
    >
      <TitleHeadSess title={"Prescripciones"} urlRedirect={"/"} />
      <Stack sx={{ width: "100%" }}>
        <PatientPicker setPatient={setPatient} />
      </Stack>
      <PrescriptionsTable
        medicalDocuments={medicalDocuments}
        loading={loading}
        page={page}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        count={totalItems}
      />
    </Stack>
  );
};

export default Prescriptions;
